import React from 'react';
import styles from './Components/CSS/BannerMid.module.css';
import { useNavigate } from 'react-router-dom';

const HeroButton = () => {
  const navigate=useNavigate()
  return (
    <div className={styles.heroContainer}>
      <img 
        src="https://images7.alphacoders.com/316/316707.jpg"
        alt="Hero Background"
        className={styles.heroImage}
      />
      <div className={styles.heroOverlay}>
        <h1 className={styles.heroTitle}>Top 10 Horror Audiobooks</h1>
        <button className={styles.exploreButton} onClick={() => navigate('/collection/category/horror')}>
          Explore Now
          <span className={styles.buttonCursor}></span>
        </button>
      </div>
    </div>
  );
};

export default HeroButton;
